import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

// Async thunk to start audit
export const startAuditAsync = createAsyncThunk(
  "audit/startAuditAsync",
  async (url, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/audit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to start audit");
      }

      const data = await response.json();
      return { auditId: data.auditId, url };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to check audit status
export const checkAuditStatus = createAsyncThunk(
  "audit/checkAuditStatus",
  async (auditId, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/audit/${auditId}`);

      if (!response.ok) {
        throw new Error("Failed to check audit status");
      }

      const data = await response.json();
      return {
        status: data.status,
        progress: data.progress,
        data: data.data,
        error: data.error,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Remove fetchReport since we get the report data from checkAuditStatus
const auditSlice = createSlice({
  name: "audit",
  initialState: {
    status: "idle", // idle, loading, polling, completed, error
    progress: 0,
    error: null,
    url: "",
    auditId: null,
    reportData: null,
  },
  reducers: {
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    resetAudit: (state) => {
      state.status = "idle";
      state.progress = 0;
      state.error = null;
      state.url = "";
      state.auditId = null;
      state.reportData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Start audit
      .addCase(startAuditAsync.pending, (state, action) => {
        state.status = "loading";
        state.url = action.meta.arg;
        state.progress = 10;
        state.error = null;
        state.reportData = null;
      })
      .addCase(startAuditAsync.fulfilled, (state, action) => {
        state.status = "polling";
        state.auditId = action.payload.auditId;
        state.progress = 20;
      })
      .addCase(startAuditAsync.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })
      // Check status
      .addCase(checkAuditStatus.fulfilled, (state, action) => {
        const { status, progress, data, error } = action.payload;

        if (status === "completed") {
          state.status = "completed";
          state.progress = 100;
          state.reportData = data;
        } else if (status === "error") {
          state.status = "error";
          state.error = error;
        } else if (status === "running") {
          state.progress = progress || state.progress;
        }
      })
      .addCase(checkAuditStatus.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { setProgress, resetAudit } = auditSlice.actions;
export default auditSlice.reducer;
